import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
interface OrderFiltersProps {
  showCompleted: boolean;
  onToggleCompleted: () => void;
  activeCount: number;
  pausedCount: number;
  completedCount: number;
}
export function OrderFilters({
  showCompleted,
  onToggleCompleted,
  activeCount,
  pausedCount,
  completedCount
}: OrderFiltersProps) {
  return <div className="flex items-center justify-between" data-id="element-576">
      <div className="flex items-center gap-6" data-id="element-577">
        <div className="flex items-center gap-2" data-id="element-578">
          <div className="w-3 h-3 rounded-full bg-blue-600" data-id="element-579" />
          <span className="text-sm text-gray-600" data-id="element-580">
            Aktiv{' '}
            <span className="font-semibold text-gray-900" data-id="element-581">({activeCount})</span>
          </span>
        </div>

        <div className="flex items-center gap-2" data-id="element-582">
          <div className="w-3 h-3 rounded-full bg-yellow-600" data-id="element-583" />
          <span className="text-sm text-gray-600" data-id="element-584">
            Pausiert{' '}
            <span className="font-semibold text-gray-900" data-id="element-585">({pausedCount})</span>
          </span>
        </div>

        <div className="flex items-center gap-2" data-id="element-586">
          <div className="w-3 h-3 rounded-full bg-green-600" data-id="element-587" />
          <span className="text-sm text-gray-600" data-id="element-588">
            Abgeschlossen{' '}
            <span className="font-semibold text-gray-900" data-id="element-589">
              ({completedCount})
            </span>
          </span>
        </div>
      </div>

      <button onClick={onToggleCompleted} className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-590">
        <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${showCompleted ? 'bg-blue-600 border-blue-600' : 'border-gray-300'}`} data-id="element-591">
          {showCompleted && <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} data-id="element-592">
              <CheckCircle className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-593" />
            </motion.div>}
        </div>
        <span className="text-sm font-medium text-gray-700" data-id="element-594">
          Abgeschlossene anzeigen
        </span>
      </button>
    </div>;
}